/* Mojito - mega-menu tile images on demand (Oct 2026 speed audit).

   snippets/header-link-image.liquid wraps each menu tile's <figure><img> in an inert
   <template data-mojito-menu-tile> inside the tile's aspect-ratio box. This inflates
   the templates of ONE menu item the first time a pointer enters it, it receives
   keyboard focus, or it is tapped: that is the moment its dropdown (desktop) or its
   sub-menu (mobile drawer) is about to open. Nothing is requested at page load.
   Measured before: 33 desktop tiles = 4.3 MB per page view, all inside a hidden menu.

   The listeners sit on document in the capture phase so they also cover menu markup
   re-rendered by the theme editor or by the header's sticky clone. Once a menu item
   is inflated it is flagged and never touched again. */
(function () {
  'use strict';
  if (window.__mojitoMenuTiles) return;
  window.__mojitoMenuTiles = true;

  var ITEM = '[data-nav-item], .mobile-menu__item--level-1';
  var TILE = 'template[data-mojito-menu-tile]';

  function inflate(item) {
    if (item.__mojitoTiles) return;
    item.__mojitoTiles = true;
    var tpls = item.querySelectorAll(TILE);
    for (var i = 0; i < tpls.length; i++) {
      var t = tpls[i];
      if (!t.content || !t.parentNode) continue;
      t.parentNode.replaceChild(t.content.cloneNode(true), t);
    }
  }

  function onIntent(e) {
    var el = e.target;
    if (el && el.nodeType !== 1) el = el.parentElement;
    if (!el || !el.closest) return;
    var item = el.closest(ITEM);
    if (item) inflate(item);
  }

  document.addEventListener('mouseover', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  document.addEventListener('click', onIntent, true);
})();
